import { format, getTime, formatDistanceToNow, startOfDay, endOfDay } from 'date-fns';
import moment from 'moment';
// ----------------------------------------------------------------------

export function fDateRangeStart(date) {
  return startOfDay(new Date(date)).toISOString(); // 2021-09-01T00:00:00.000Z
}

export function fDateRangeEnd(data) {
  return endOfDay(new Date(data)).toISOString(); // 2021-09-01T23:59:59.999Z
}

export function fDate(date, withTime = false) {
  return format(new Date(date), `LLL dd, yyyy${withTime ? ' hh:mm a' : ''}`, { timeZone: 'Asia/Taipei' });
}

export function fDateTimeLocal(date) {
  if (!date) return new Date()?.toISOString().slice(0, 11) + new Date().toTimeString().slice(0, 5);
  return new Date(date)?.toISOString().slice(0, 11) + new Date(date).toTimeString().slice(0, 5);
}

export function fDateYear(date) {
  return format(new Date(date), `yyyy`);
}

export function fDateTime(date) {
  return format(new Date(date), 'dd MMM yyyy HH:mm');
}

export function fTimestamp(date) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
  });
}

export function convertTime(input) {
  return moment(input, 'HH:mm').format('h:mm A');
}

export function getAge(dateString) {
  if (!dateString) return '--';

  const today = new Date();
  const birthDate = new Date(dateString);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age -= 1;
  }
  return age;
}
